import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

// Dynamically determine the base URL based on the current location
const getBaseUrl = () => {
    const { protocol, host } = window.location;
    return `${protocol}//${host}/api/v1`;
};

export const confApi = createApi({
    reducerPath: 'confApi',
    baseQuery: fetchBaseQuery({
        baseUrl: getBaseUrl(),
    }),

    tagTypes: [`conferences`, `conference`, `participants`,],

    endpoints: (builder) => ({

        /////// Conference API
        getConf: builder.query({
            query: () => `/conferences`,
            //To automat-refetch in query mode
            providesTags: [`conferences`]
        }),

        getConferenceStatus: builder.query({
            query: ({ id }) => `/conferences/${id}`,

        }),

        createConf: builder.mutation({
            query: ({ body }) => ({
                url: `/conferences`,
                method: 'POST',
                body,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),

            //To automat-refetch in mutation mode
            invalidatesTags: [{ type: 'conferences' }],
        }),

        findConference: builder.query({
            query: ({ pId }) => `/${pId}`,
        }),

        deleteConf: builder.mutation({
            query: ({ id }) => ({
                url: `/conferences/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: (result, error, id) => [{ type: 'conferences' }],

        }),

        ///////// Participant API
        getParticipant: builder.query({
            query: ({ pId }) => `/participants/${pId}`,

            providesTags: [`participants`]
        }),

        getParticipantsList: builder.query({
            query: ({ id }) => `/conferences/${id}/participants`,

            providesTags: [`participants`]
        }),

        addParticipant: builder.mutation({
            query: ({ participant, cId }) => ({
                url: `/conferences/${cId}/participants`,
                method: 'POST',
                body: participant,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: [`participants`]
        }),

        updateParticipant: builder.mutation({
            query: ({ pId, ...rest }) => ({
                url: `/participants/${pId}`,
                method: 'PUT',
                body: rest,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: [`participants`]

        }),

        deleteParticipant: builder.mutation({
            query: ({ info }) => ({
                url: `/conferences/${info.cId}/participants/${info.pId}`,
                method: 'DELETE',
            }),

            invalidatesTags: (result, error, id) => [{ type: 'participants' }],
        }),
    }),
})

export const {
    useGetConfQuery,
    useCreateConfMutation,
    useGetConferenceStatusQuery,
    useFindConferenceQuery,
    useDeleteConfMutation,
    useAddParticipantMutation,
    useGetParticipantQuery,
    useGetParticipantsListQuery,
    useUpdateParticipantMutation,
    useDeleteParticipantMutation,
} = confApi